import store from "app/redux/store/store";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import * as R from 'ramda'
import {IOrcamento} from "../../types/IOrcamento";

export const popularPropriedadesNovoItem = ({
        item, corPorAmbiente, informacoesOrcamento,valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL
    }:{item: IItemOrcamento, corPorAmbiente: {[key:string] : string}, informacoesOrcamento: Partial<IOrcamento>,valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL:string}) : IItemOrcamento => {
        return {
            ...item,
            AtualizarVendaSobEncomenda: false,
            PreservaDesconto: item.PreservaDesconto,
            AtualizarRemoto: true,
            CodigoTipoEntregaAnterior: item.CodigoTipoEntrega,
            QuantidadeAnterior: item.Quantidade,
            CodigoFilialRetiradaAnterior: item.CodigoFilialRetirada,
            OcultarRetiradaOutroLocal: informacoesOrcamento?.TipoOrcamentoDescricao == "Outras Saídas" && valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL !== "S",
            DescricaoTipoOrcamento:
                    informacoesOrcamento.TipoOrcamento === 1  ?
                        "Outras Saídas":
                        informacoesOrcamento.TipoOrcamento === 2 ?
                            "Transferências" :
                            "Venda",
            TipoOrcamento: informacoesOrcamento.TipoOrcamento,
            SimulandoDesconto: false,
            PossuiDataMarcadaEntrega: item.DataMarcadaEntrega != null ? true : null,
            Atualizar: false,
            selecionado: null,
            CorAmbiente: R.tryCatch(() => corPorAmbiente[item.Ambiente], R.always(null)) ()
        }
}
